module.exports = "/_next/static/images/search_bg_7-91ea05c4782b5b5f147db147dd593982.jpg";